import { PrismicText } from "@prismicio/react";
import { useLinks } from "@src/cms/useLinks";
import { useSidebarAccueil } from "@src/cms/useSidebarAccueil";
import { Link } from "@endya-conformite/ui-kit";
import { UserMenu } from "@src/components/UserMenu/UserMenu";
import styles from "./Home.module.scss";

export function HomeRightSidebar() {
  const { accueilSidebar } = useSidebarAccueil();
  const {
    cgu,
    mentions_legales: mentionsLegales,
    politique_de_confidentialite: politiqueDeConfidentialite,
  } = useLinks();

  return (
    <div className={styles.pageAside}>
      <div className={styles.pageAsideHeader}>
        <UserMenu />
      </div>
      <div className={styles.pageAsideBody}>
        <div className={styles.pageAsideContent}>
          <h2 className={styles.pageAsideTitle}>Nos services</h2>
          <div className={styles.service}>
            {accueilSidebar?.group.map((doc, index) => (
              <Link
                key={doc.pages?.id ?? index}
                to={`/services/${doc.pages?.uid ?? ""}`}
                className={styles.serviceLink}
              >
                <PrismicText field={doc.pages?.data?.titre_lien} />
              </Link>
            ))}
          </div>

          <h2 className={styles.pageAsideTitle}>Contact</h2>
          <div className={styles.service}>
            <Link to="mailto:support@endya.fr" className={styles.pageAsideMail}>
              support@endya.fr
            </Link>
          </div>
        </div>

        <div>
          <hr className={styles.pageAsideSeparator} />
          <div className={styles.service}>
            {cgu && (
              <Link
                target="_blank"
                to={cgu.value}
                className={styles.serviceLink}
              >
                {cgu.label}
              </Link>
            )}
            {mentionsLegales && (
              <Link
                target="_blank"
                to={mentionsLegales.value}
                className={styles.serviceLink}
              >
                {mentionsLegales.label}
              </Link>
            )}
            {politiqueDeConfidentialite && (
              <Link
                target="_blank"
                to={politiqueDeConfidentialite.value}
                className={styles.serviceLink}
              >
                {politiqueDeConfidentialite.label}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
